import { Component, OnInit } from '@angular/core';
import { SrubUpService } from '../Services/ScrubUp.service';
import { UserService } from '../Services/user.service';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { AnalyticsDataDTO,  RolesDataDTO } from '../Models/Speciality.model';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  providers: [SrubUpService, UserService]
})

export class AnalyticsComponent implements OnInit {
  data:any;


  analyticsDataToDisplay: AnalyticsDataDTO;
  public loading = false;
  publicCount:number;
  privateCount:number;
  loginUserId: number;
  roleData:RolesDataDTO;
  rolesDataToDispaly:Array<RolesDataDTO>;

  constructor(private userService: UserService, private cookieService: CookieService, private appUser: AppWideUser, private token: Token, private scrubUpService: SrubUpService) {


    if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.loginUserId = this.appUser.UserId;
    this.rolesDataToDispaly = new Array<RolesDataDTO>();

    this.analyticsDataToDisplay = new AnalyticsDataDTO();

  }







  ngOnInit() {
    this.GetAnalyticsData();
  }

  GetAnalyticsData() {
    this.loading = true;
    this.scrubUpService.GetAnalyticsData(this.token).subscribe(x => {
      if (x != null && x != undefined) {
        this.rolesDataToDispaly = x;
      }
      this.loading = false;
      // this.publicCount = this.analyticsDataToDisplay.PublicCount;
      // this.privateCount = this.analyticsDataToDisplay.PrivateCount;

      // for (let index = 0; index < this.analyticsDataToDisplay.RoleData.length; index++) {
      //   const element = this.analyticsDataToDisplay.RoleData[index];
      //   this.roleData = new RolesDataDTO();
      //   this.roleData.count = element.count;
      //   this.roleData.RoleName = element.RoleName;
      //   this.rolesDataToDispaly.push(this.roleData);
      // }
    },
      error => {
        this.loading = false;
      })
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/analytics/analytics.component.ts